export default __webpack_public_path__ + "static/media/hybrid.342eac11.png";